import React, { ReactElement } from 'react';
import Image from '@components/Image';

type CartBannerProps = {
    image?: string;
    title?: string;
    text?: string;
}

const CartBanner = (props: CartBannerProps) :  ReactElement => {
    const {
        image,
        title,
        text
    } = props;

    let isLoading = true;

    return (
        <div className="cart-banner">
            {!!image && 
                <div className="cart-banner-icon">
                    <Image 
                        width='32px'
                        height='32px'
                        src={image}
                        alt='alt image'
                    />
                </div>
            }
            <div className="cart-banner-content">
                {title &&
                    <div className="cart-banner-content-title">
                        {title}
                    </div>
                }
                {text && 
                    <div className="cart-banner-content-text">
                        {text}
                    </div>
                }
            </div>
        </div>
    );
}

export default CartBanner;